import type { TranslationTree } from '../locale.model';

export const commonEn: TranslationTree = {
  app: {
    name: 'Fisital.ai',
    product: 'License Manager',
  },
  cancel: 'Cancel',
  save: 'Save',
  saveChanges: 'Save changes',
  saving: 'Saving…',
  savingEllipsis: 'Saving...',
  delete: 'Delete',
  deleting: 'Deleting...',
  edit: 'Edit',
  remove: 'Remove',
  close: 'Close',
  ok: 'OK',
  create: 'Create',
  add: 'Add',
  back: 'Back',
  retry: 'Try again',
  confirmDelete: 'Confirm deletion',
  confirmDeleteQuestion: 'Do you really want to delete',
  loading: 'Loading…',
  noResults: 'No results found.',
  actions: 'Actions',
  name: 'Name',
  description: 'Description',
  status: 'Status',
  email: 'Email',
  phone: 'Phone',
  select: 'Select',
  all: 'All',
  allFeminine: 'All',
  active: 'Active',
  inactive: 'Inactive',
  activeFeminine: 'Active',
  inactiveFeminine: 'Inactive',
  undefined: 'Undefined',
  rows: 'Rows',
  page: 'Page',
  of: 'of',
  total: 'in total',
  registered: 'Registered',
  registeredCount: '{{count}} registered',
  yes: 'YES',
  no: 'NO',
  filters: 'Filters:',
  search: 'Search',
  exportPdf: 'Export PDF',
  width: 'Width',
  icon: 'Icon',
  type: 'Type',
  code: 'Code',
  region: 'Region',
  clients: 'Clients',
  category: 'Category',
  section: 'Section',
  path: 'Path',
  marker: 'Marker',
  optional: 'optional',
  noFile: 'No file selected',
  noPreview: 'No preview',
  noFileShort: 'No file',
  browse: 'Browse',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  activateAll: 'Activate all',
  deactivateAll: 'Deactivate all',
  details: 'Details',
  preview: 'Preview',
  validation: 'Validation',
  theme: {
    light: 'Enable light theme',
    dark: 'Enable dark theme',
  },
  installation: {
    cloud: 'Cloud',
    onpremise: 'On-premise',
    hybrid: 'Hybrid',
  },
  menuBullet: {
    bullet: 'Bullet (dot)',
    line: 'Line',
  },
  lang: {
    ptBr: 'Portuguese (BR)',
    pt: 'Portuguese',
    en: 'English',
    es: 'Spanish',
  },
  pagination: {
    total: '({{total}} total)',
    updating: 'Updating list…',
  },
  errors: {
    apiConnection: 'Could not connect to the API. Check the URL and CORS.',
    httpStatus: 'Error {{status}}',
    invalidCompanyResponse: 'Invalid response while saving the company.',
    invalidProfileCreateResponse: 'Invalid response while creating the profile.',
    invalidProfileResponse: 'Invalid profile response.',
    invalidResetPasswordResponse: 'Invalid response while resetting the password.',
    invalidUserResponse: 'Invalid response while creating the user.',
    missingNewPassword: 'The API did not return the new temporary password.',
    missingTemporaryPassword: 'The API did not return the temporary password for the new user.',
    loginFailed: 'Login failed. Please try again.',
  },
};

export const authEn: TranslationTree = {
  welcome: 'Welcome',
  subtitle: 'Sign in with your credentials',
  usernameLabel: 'Email or username',
  usernamePlaceholder: 'you@email.com',
  passwordLabel: 'Password',
  passwordPlaceholder: '••••••••',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  submit: 'Sign in',
  submitting: 'Signing in…',
  configLoading: 'Loading…',
  retryConfig: 'Try again',
  error: {
    fillCredentials: 'Enter username and password.',
  },
};

export const navEn: TranslationTree = {
  main: 'Main',
  companies: 'Companies',
  manufacturers: 'Manufacturers',
  resellers: 'Resellers',
  operators: 'Operator Management',
  parameterizations: 'Parameterizations',
  menus: 'Menus',
  tickets: 'Ticket Center',
  knowledgeBase: 'Knowledge Base',
  ambience: 'Ambience',
  colorPalettes: 'Color palettes',
  collapse: 'Collapse',
  collapseAria: 'Collapse or expand menu',
  plansPro: 'Pro Plans',
  upgradeEnterprise: 'Upgrade to Enterprise',
  validUntil: 'Valid until December 31, 2026',
  languageAria: 'Language: {{locale}}',
  notificationsAria: 'Notifications, 3 new',
  accountMenuAria: 'Account menu',
  userFallback: 'User',
  myProfile: 'My Profile',
  logout: 'Sign out',
};

export const dashboardEn: TranslationTree = {
  title: 'Dashboard',
  subtitle: 'Overview of licensing, operations and consumption',
  planPro: 'Pro Plan',
  upgrade: 'Upgrade',
  alerts: {
    title: 'Active alerts',
    llmTitle: 'LLM tokens — 90% capacity',
    llmBody: 'Approaching the contracted package limit.',
    conversationsTitle: 'Conversations — 78% capacity',
    conversationsBody: 'Monitor volume to avoid blocks.',
  },
  metrics: {
    aria: 'Main metrics',
    operators: 'Operators',
    active: 'active',
    activeModules: 'Active modules',
    available: 'available',
    contractDeadline: 'Contract deadline',
    days: 'days',
    nextBilling: 'Next billing',
    billingStatus: 'Invoice · Up to date',
  },
  verticals: {
    title: 'Active verticals',
    banking: 'Banking',
    retail: 'Retail',
    industry: 'Industry',
    active: 'Active',
  },
  resources: {
    title: 'Licensed resources',
    cameras: 'Cameras',
    locations: 'Locations',
    users: 'Users',
    storage: 'Storage',
  },
  userDistribution: {
    title: 'User distribution',
    admins: 'Admin',
    operators: 'Operators',
    viewers: 'Viewers',
  },
  ai: {
    title: 'AI & Consumption',
    apiRequests: 'API requests',
    inferenceJobs: 'Inference jobs',
    avgStorage: 'Average storage',
    perMonth: 'this month',
    completed: 'completed',
    perProject: 'per project',
  },
};
